class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
    this.style.display = 'none'; // do not break dom slots
  }


  connectedCallback() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.envyLoadKey;

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      // Speed (Claude, 8 Oct 2026): if the browser has already started fetching this script (it was part of the page's HTML,
      // so it will run on its own), don't add a second copy. Scripts added later by AJAX never start a fetch, so they still load here.
      const alreadyFetching = performance.getEntriesByType('resource').some((e) => e.name === script.src);
      if(!scriptLoaded && !alreadyFetching) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;
            

        this.appendChild(postLoadedScript);

      }
    })
        
  }
}

customElements.define('safe-load-scripts', SafeLoadScripts);
